<template lang="pug">
.cp-callai-top
  .w
    .title 关于去电
    .content
      p.content-title 托付信任、共创未来
      p &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;万蚓网络科技(上海)有限公司『去电人工智能』，由一支持续创业多年的互联网团队发起于2016年底，团队核心成员均为从业10年以上的互联网专家，来自于阿里巴巴、腾讯、IBM、华为等知名科技企业。团队历经数轮创业累计获投数千万元融资，所涉及项目均已实现资本化。
      p &nbsp;&nbsp;&nbsp;&nbsp;“万蚓”二字中，“万”取自于“万夫之勇、万人一心”，“蚓”取自于《劝学》，其意喻团队合力拼搏，用心专一，持续学习，薪火传承的核心价值理念。
    .content2
      p 去电人工智能面向精准营销市场，以语音交互场景为切入点，通过应用和服务，成为企业数据智能营销的坚实伙伴。通过打造“数据、场景、互动”的融合，形成全新的智能化精准营销服务通路。
      p 公司成立至今，已完成业绩环比 400%以上增长并实现盈利，2019年初获得千万级Pre-A轮融资。
    ul.num-list
      li.item(v-for="(v, index) in list")
        .num-wrap
          img(:src="v.img")
          p {{v.label}}
        .bg(:class="`bg${index}`")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      list: [
        { img: require('@/assets/400.png'), label: '业绩增长量' },
        { img: require('@/assets/70.png'), label: '研发人员' },
        { img: require('@/assets/100.png'), label: '核心客户' },
      ]
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
@import 'config'
.cp-callai-top
  padding-top $topbar-height
  margin-bottom 173px
  background url('../../../assets/about-bg.jpg') bottom / 100% no-repeat
  @media screen and (max-width: 1920px) {
    background url('../../../assets/about-bg.jpg') top / 100% no-repeat
  }
  .title
    margin-top 84px
  .content
    width 900px
    height 420px
    margin 80px auto 100px
    padding 92px 170px 73px
    background linear-gradient(90deg,rgba(23,36,80,0.4) 0%,rgba(23,36,80,0.8) 22%,rgba(23,36,80,1) 40%,rgba(23,36,80,1) 100%)
    .content-title
      text-indent 15px
      font-size 24px
      color rgba(158,234,250,1)
      margin-bottom 27px
    p
      font-size 16px
      line-height 28px
      &:last-child
        color #9EEAFA
  .content2
    width 560px
    margin 0px auto
    p
      font-size 16px
      line-height 28px
      margin-bottom 10px
  .num-list
    width 610px
    margin 72px auto 0px
    display flex
    justify-content space-between
    .item
      position relative
      &:hover
        .bg
          transform rotate(720deg)
      .num-wrap
        p
          margin-top 16px
          font-size 18px
          color rgba(255,255,255,0.6)
      &:nth-child(1)
        img
          width 100px
        .bg
          height 100px
      &:nth-child(2)
        img
          width 75px
      &:nth-child(3)
        img
          width 95px
        p
          text-indent 2px
      .bg
        width 100px
        height 110px
        position absolute
        left 20px
        top 20px
        transition all 4s linear
      .bg0
        background url('../../../assets/zengzhang.png') center / 100%
      .bg1
        background url('../../../assets/yanfa.png') center / 100%
      .bg2
        background url('../../../assets/kehu.png') center / 100%
</style>
